var _style, _defs, _defs2, _defs3, _defs4, _defs5, _defs6, _defs7, _defs8, _defs9, _defs10, _defs11, _defs12, _defs13, _defs14, _defs15, _defs16, _defs17, _defs18, _defs19, _defs20, _defs21, _defs22, _defs23, _defs24, _defs25, _defs26, _defs27, _defs28, _defs29, _defs30, _defs31, _defs32;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgMeetecbanner(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 1920 1080",
    style: {
      enableBackground: "new 0 0 1920 1080"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{clip-path:url(#SVGID_00000167389758598703075800000008328700618595710082_);fill:#FFFFFF;}\n\t.st1{clip-path:url(#SVGID_00000003066812917659361900000014115276015975033493_);fill:#FFFFFF;}\n\t.st2{clip-path:url(#SVGID_00000131354388094945743530000007312043429847075217_);fill:#FFFFFF;}\n\t.st3{clip-path:url(#SVGID_00000082325962872810933080000009994403096718250918_);fill:#FFFFFF;}\n\t.st4{clip-path:url(#SVGID_00000135685776920066801700000016130297073663665537_);fill:#FFFFFF;}\n\t.st5{clip-path:url(#SVGID_00000003085941796191193090000011870069318741233551_);fill:#FFFFFF;}\n\t.st6{clip-path:url(#SVGID_00000149365703082943096900000009401020831484658306_);fill:#FFFFFF;}\n\t.st7{clip-path:url(#SVGID_00000048469729705159869380000010568231939128972190_);fill:#FFFFFF;}\n\t.st8{clip-path:url(#SVGID_00000023979353740226412170000006917677522678640277_);fill:#FFFFFF;}\n\t.st9{clip-path:url(#SVGID_00000018953221945409139000000003960578635624399021_);fill:#FFFFFF;}\n\t.st10{clip-path:url(#SVGID_00000144311467153107096250000012984741606364073395_);fill:#FFFFFF;}\n\t.st11{clip-path:url(#SVGID_00000067220734393350978910000005550784942720421552_);fill:#FFFFFF;}\n\t.st12{clip-path:url(#SVGID_00000016058162910800368420000017936088616708577671_);fill:#FFFFFF;}\n\t.st13{clip-path:url(#SVGID_00000019658461035815459930000010189661205018065583_);fill:#FFFFFF;}\n\t.st14{clip-path:url(#SVGID_00000020394109467599160060000009974533931858343561_);fill:#FFFFFF;}\n\t.st15{clip-path:url(#SVGID_00000099651811506315740770000008969081244316960435_);fill:#FFFFFF;}\n\t.st16{clip-path:url(#SVGID_00000063629116574946018880000001008089712977345943_);fill:#FFFFFF;}\n\t.st17{clip-path:url(#SVGID_00000101781394429136374670000015457677800969850301_);fill:#FFFFFF;}\n\t.st18{clip-path:url(#SVGID_00000044865059428248479490000002541706790663912095_);fill:#FFFFFF;}\n\t.st19{clip-path:url(#SVGID_00000032632623211515171530000005750426750885659285_);fill:#FFFFFF;}\n\t.st20{clip-path:url(#SVGID_00000176008710432604315050000013265221606701713051_);fill:#FFFFFF;}\n\t.st21{clip-path:url(#SVGID_00000096760610137690430390000005613569173201833646_);fill:#FFFFFF;}\n\t.st22{clip-path:url(#SVGID_00000138567266569206516470000003035124701339932308_);fill:#FFFFFF;}\n\t.st23{clip-path:url(#SVGID_00000094596932842044601050000014441767719862638982_);fill:#FFFFFF;}\n\t.st24{clip-path:url(#SVGID_00000054966162626745582090000014956874030578403987_);fill:#FFFFFF;}\n\t.st25{clip-path:url(#SVGID_00000073715333226889847260000008008049371554083493_);fill:#FFFFFF;}\n\t.st26{clip-path:url(#SVGID_00000166644371220160315440000002737932422520291211_);fill:#FFFFFF;}\n\t.st27{clip-path:url(#SVGID_00000024723500129494936930000006166577283115703227_);fill:#FFFFFF;}\n\t.st28{clip-path:url(#SVGID_00000111164307005487107380000015163714866011058346_);fill:#FFFFFF;}\n\t.st29{clip-path:url(#SVGID_00000070114997446146166200000001793888888672309661_);fill:#FFFFFF;}\n\t.st30{clip-path:url(#SVGID_00000058584976007087721180000000251985982323877816_);fill:#FFFFFF;}\n\t.st31{clip-path:url(#SVGID_00000137841051577577597350000007561275415019509687_);fill:#FFFFFF;}\n")), /*#__PURE__*/React.createElement("g", null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("polygon", {
    id: "SVGID_1_",
    points: "93.6,186.9 90.4,135.5 93,135.5 154.7,231.5 167.3,231.5 226.3,135.5 229.5,135.5 226.8,192.7  226.8,388.5 299,388.5 299,21 226.3,21 163.6,122.8 161.5,122.8 98.3,21 25.1,21 25.1,388.5 93.6,388.5  "
  }))), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_1_",
    style: {
      overflow: "visible",
      fill: "#FFFFFF"
    }
  }), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000068664591482192321070000006949547062096658592_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_1_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("rect", {
    x: 16.8,
    y: 12.7,
    style: {
      clipPath: "url(#SVGID_00000068664591482192321070000006949547062096658592_)",
      fill: "#FFFFFF"
    },
    width: 290.4,
    height: 384
  })), /*#__PURE__*/React.createElement("g", null, _defs2 || (_defs2 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("polygon", {
    id: "SVGID_00000044153185067549092570000005037372244984268194_",
    points: "604,324.5 430.8,324.5 430.8,234.7 588.1,234.7  588.1,170.6 430.8,170.6 430.8,85 601.4,85 601.4,21 358.3,21 358.3,388.5 604,388.5  "
  }))), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000044153185067549092570000005037372244984268194_",
    style: {
      overflow: "visible",
      fill: "#FFFFFF"
    }
  }), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000128486095096596618020000005256896363881095847_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000044153185067549092570000005037372244984268194_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("rect", {
    x: 350,
    y: 12.7,
    style: {
      clipPath: "url(#SVGID_00000128486095096596618020000005256896363881095847_)",
      fill: "#FFFFFF"
    },
    width: 262.2,
    height: 384
  })), /*#__PURE__*/React.createElement("g", null, _defs3 || (_defs3 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("polygon", {
    id: "SVGID_00000045601603973804235420000006783541148566664082_",
    points: "920.3,324.5 747.1,324.5 747.1,234.7  904.4,234.7 904.4,170.6 747.1,170.6 747.1,85 917.6,85 917.6,21 674.6,21 674.6,388.5 920.3,388.5  "
  }))), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000045601603973804235420000006783541148566664082_",
    style: {
      overflow: "visible",
      fill: "#FFFFFF"
    }
  }), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000059284907607419840510000004030385570102937279_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000045601603973804235420000006783541148566664082_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("rect", {
    x: 666.3,
    y: 12.7,
    style: {
      clipPath: "url(#SVGID_00000059284907607419840510000004030385570102937279_)",
      fill: "#FFFFFF"
    },
    width: 262.2,
    height: 384
  })), /*#__PURE__*/React.createElement("g", null, _defs4 || (_defs4 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "SVGID_00000023974053865665996970000015224270713685855416_",
    d: "M1014.8,260.4c0,47.4,9.9,82.1,29.8,103.8 c19.9,21.8,49.5,32.7,88.9,32.7c10.9,0,22-1.2,33.2-3.6c11.3-2.5,22.1-5.8,32.5-10.2c10.4-4.3,20.1-9.4,29-15.2 c9-5.8,16.5-12.1,22.4-19.1l-31.7-47.1c-4.2,3.5-8.9,7.3-14,11.5c-5.1,4.2-10.7,8-16.9,11.5c-6.2,3.5-13.1,6.4-20.8,8.6 c-7.8,2.3-16.3,3.4-25.8,3.4c-18.3,0-32.5-6-42.7-18c-10.2-12-15.3-31.5-15.3-58.3v-74.8h138.2V128h-138.2v-79l-68.6,19.4v59.6 h-52.2v57.6h52.2L1014.8,260.4L1014.8,260.4z"
  }))), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000023974053865665996970000015224270713685855416_",
    style: {
      overflow: "visible",
      fill: "#FFFFFF"
    }
  }), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000085208111679786957820000001471781737480444052_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000023974053865665996970000015224270713685855416_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("rect", {
    x: 954.4,
    y: 40.8,
    style: {
      clipPath: "url(#SVGID_00000085208111679786957820000001471781737480444052_)",
      fill: "#FFFFFF"
    },
    width: 304.6,
    height: 364.4
  })), /*#__PURE__*/React.createElement("g", null, _defs5 || (_defs5 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "SVGID_00000160894158456180477560000004919619680629047952_",
    d: "M1375.9,206.6c4.2-7.1,9.5-13.1,16-17.9 c6.5-4.8,13.7-8.5,21.8-11c8.1-2.5,16.6-3.8,25.7-3.8c19.6,0,34.2,5.1,43.9,15.3c9.6,10.2,14.4,24,14.4,41.5h-129.2 C1369.2,221.8,1371.7,213.7,1375.9,206.6z M1336.5,359.8c12.2,12.1,27.2,21.3,44.9,27.6c17.7,6.3,37.7,9.5,60.1,9.5 c12.9,0,25.2-1.1,36.8-3.2c11.5-2.1,22.1-4.9,31.8-8.4c9.6-3.5,18-7.3,25.2-11.3c7.2-4,13-8.2,17.6-12.4l-22.6-44.7 c-8.4,7-19.3,13-32.8,17.9c-13.5,4.9-30.7,7.4-51.7,7.4c-10.5,0-20.4-1.1-29.7-3.4c-9.3-2.3-17.5-5.9-24.7-10.8 c-7.2-4.9-12.9-11.2-17.3-18.9c-4.4-7.7-6.8-17.2-7.1-28.4H1556c3.5-17.5,5.3-33.8,5.3-48.9c0-22.1-3.8-40.3-11.3-54.7 c-7.5-14.4-17.2-25.9-29.2-34.5c-11.9-8.6-25-14.6-39.1-18.1c-14.2-3.5-27.9-5.3-41.2-5.3c-20,0-38.5,2.9-55.7,8.7 c-17.2,5.8-32.1,14.5-44.9,26c-12.8,11.6-22.8,26-30.2,43.4c-7.4,17.4-11,37.6-11,60.8c0,21.7,3.2,41.1,9.7,58.1 C1314.9,333.2,1324.2,347.7,1336.5,359.8z"
  }))), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000160894158456180477560000004919619680629047952_",
    style: {
      overflow: "visible",
      fill: "#FFFFFF"
    }
  }), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000088827142724163546740000011421781915262636474_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000160894158456180477560000004919619680629047952_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("rect", {
    x: 1290.4,
    y: 110.9,
    style: {
      clipPath: "url(#SVGID_00000088827142724163546740000011421781915262636474_)",
      fill: "#FFFFFF"
    },
    width: 279.1,
    height: 294.3
  })), /*#__PURE__*/React.createElement("g", null, _defs6 || (_defs6 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "SVGID_00000160870855693770767550000005186507998109593006_",
    d: "M1657.8,358.8c12.1,12.1,27.1,21.5,44.8,28.1 c17.7,6.7,38.1,10,60.9,10c21.1,0,41.3-2.7,60.6-8.2c19.3-5.4,36.2-13.6,50.6-24.5l-22.7-51c-6.3,4.2-15.9,9.1-28.7,14.7 c-12.8,5.6-29.3,8.4-49.3,8.4c-12.7,0-24.2-2-34.6-6c-10.4-4-19.1-9.6-26.1-16.6c-7.1-7-12.5-15.3-16.3-24.7 c-3.9-9.5-5.8-19.8-5.8-31c0-13.7,2.4-25.4,7.1-35.2c4.7-9.8,10.9-18,18.4-24.5c7.6-6.5,16.2-11.2,25.8-14.2 c9.7-3,19.4-4.5,29.3-4.5c10.9,0,21.8,1.2,32.7,3.7v48.4h58v-92.6c-9.2-4.2-22.3-8.6-39.5-13.2c-17.2-4.6-35.7-6.8-55.4-6.8 c-21.1,0-40.6,3.1-58.5,9.2c-17.9,6.1-33.5,15.2-46.6,27.1c-13.2,11.9-23.5,26.5-30.8,43.7c-7.4,17.2-11.1,36.8-11.1,58.9 c0,20.7,3.2,39.6,9.5,56.8C1636.4,332.1,1645.7,346.7,1657.8,358.8z"
  }))), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000160870855693770767550000005186507998109593006_",
    style: {
      overflow: "visible",
      fill: "#FFFFFF"
    }
  }), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000172429555455372380970000017147702342565518004_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000160870855693770767550000005186507998109593006_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("rect", {
    x: 1612.3,
    y: 110.9,
    style: {
      clipPath: "url(#SVGID_00000172429555455372380970000017147702342565518004_)",
      fill: "#FFFFFF"
    },
    width: 270.7,
    height: 294.3
  })), /*#__PURE__*/React.createElement("g", null, _defs7 || (_defs7 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("polygon", {
    id: "SVGID_00000134931153912490756230000000786853544131140278_",
    points: "146.8,736.4 177.6,736.4 177.6,604.5  122.9,604.5 102.6,714.7 82.6,604.5 27.9,604.5 27.9,736.4 58.7,736.4 58.7,625 82.1,736.4 123.9,736.4 146.8,625.3  "
  }))), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000134931153912490756230000000786853544131140278_",
    style: {
      overflow: "visible",
      fill: "#FFFFFF"
    }
  }), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000111156282095799717930000013560950389542543764_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000134931153912490756230000000786853544131140278_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("rect", {
    x: 19.6,
    y: 596.3,
    style: {
      clipPath: "url(#SVGID_00000111156282095799717930000013560950389542543764_)",
      fill: "#FFFFFF"
    },
    width: 166.2,
    height: 148.4
  })), /*#__PURE__*/React.createElement("g", null, _defs8 || (_defs8 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("polygon", {
    id: "SVGID_00000173162369774871392330000015931266053274813071_",
    points: "282.1,628.7 282.1,604.5 197.3,604.5  197.3,736.4 282.1,736.4 282.1,712.3 230.2,712.3 230.2,682.3 271.9,682.3 271.9,658.2 230.2,658.2 230.2,628.7  "
  }))), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000173162369774871392330000015931266053274813071_",
    style: {
      overflow: "visible",
      fill: "#FFFFFF"
    }
  }), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000013898960846485427690000012377922658007188650_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000173162369774871392330000015931266053274813071_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("rect", {
    x: 189.1,
    y: 596.3,
    style: {
      clipPath: "url(#SVGID_00000013898960846485427690000012377922658007188650_)",
      fill: "#FFFFFF"
    },
    width: 101.2,
    height: 148.4
  })), /*#__PURE__*/React.createElement("g", null, _defs9 || (_defs9 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "SVGID_00000086680338930594015030000015193434931529605546_",
    d: "M395.5,722.1c4.6-5.1,8-10.7,10.2-16.7 c2.2-6.1,3.4-12.1,3.4-18h-32.2c0,3.6-0.5,7-1.6,10.2s-2.6,6-4.6,8.4c-2,2.4-4.5,4.3-7.4,5.7s-6.2,2.1-9.9,2.1 c-5.3,0-10-1.5-14.1-4.6c-4.1-3.1-7.4-7.8-9.8-14.2c-2.4-6.4-3.6-14.7-3.6-24.7c0-10,1.2-18.3,3.6-24.6c2.4-6.4,5.7-11.1,9.8-14.1 c4.1-3,8.8-4.5,14.1-4.5c4.4,0,8.2,0.9,11.4,2.7c3.2,1.8,5.8,4.3,7.8,7.5c2,3.1,3.3,6.8,3.9,11c0.2,1.6,0.4,3.3,0.4,5.1h32.2 c0-4-0.5-8.2-1.6-12.5c-1.7-6.7-4.8-13-9.3-18.9c-4.5-6-10.5-10.8-17.9-14.5c-7.4-3.7-16.4-5.6-26.9-5.6 c-12.6,0-23.5,2.9-32.5,8.8c-9,5.9-15.9,13.9-20.6,24.2c-4.7,10.3-7.1,22.2-7.1,35.7c0,13.5,2.4,25.4,7.1,35.7 c4.7,10.3,11.6,18.5,20.6,24.3c9,5.9,19.8,8.8,32.5,8.8c9.5,0,17.8-1.6,24.8-4.7c7-3.1,12.8-7.2,17.3-12.3V722.1z"
  }))), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000086680338930594015030000015193434931529605546_",
    style: {
      overflow: "visible",
      fill: "#FFFFFF"
    }
  }), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000016077477397913798770000004370271344508624817_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000086680338930594015030000015193434931529605546_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("rect", {
    x: 285.1,
    y: 593.5,
    style: {
      clipPath: "url(#SVGID_00000016077477397913798770000004370271344508624817_)",
      fill: "#FFFFFF"
    },
    width: 132.3,
    height: 154
  })), /*#__PURE__*/React.createElement("g", null, _defs10 || (_defs10 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("polygon", {
    id: "SVGID_00000179645669814239457230000010054636982947732631_",
    points: "426.1,604.5 426.1,736.4 458.7,736.4  458.7,682.8 503.6,682.8 503.6,736.4 536.2,736.4 536.2,604.5 503.6,604.5 503.6,658.7 458.7,658.7 458.7,604.5  "
  }))), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000179645669814239457230000010054636982947732631_",
    style: {
      overflow: "visible",
      fill: "#FFFFFF"
    }
  }), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000150077686947314722610000003515175733033639812_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000179645669814239457230000010054636982947732631_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("rect", {
    x: 417.8,
    y: 596.3,
    style: {
      clipPath: "url(#SVGID_00000150077686947314722610000003515175733033639812_)",
      fill: "#FFFFFF"
    },
    width: 126.7,
    height: 148.4
  })), /*#__PURE__*/React.createElement("g", null, _defs11 || (_defs11 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("polygon", {
    id: "SVGID_00000029014754156482991030000006948543941712798381_",
    points: "640.7,628.7 640.7,604.5 556,604.5 556,736.4  640.7,736.4 640.7,712.3 588.8,712.3 588.8,682.3 630.6,682.3 630.6,658.2 588.8,658.2 588.8,628.7  "
  }))), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000029014754156482991030000006948543941712798381_",
    style: {
      overflow: "visible",
      fill: "#FFFFFF"
    }
  }), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000002351074036410305110000006336807848493976206_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000029014754156482991030000006948543941712798381_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("rect", {
    x: 547.7,
    y: 596.3,
    style: {
      clipPath: "url(#SVGID_00000002351074036410305110000006336807848493976206_)",
      fill: "#FFFFFF"
    },
    width: 101.2,
    height: 148.4
  })), /*#__PURE__*/React.createElement("g", null, _defs12 || (_defs12 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("polygon", {
    id: "SVGID_00000092449323169254088890000006774149065859407522_",
    points: "660.5,604.5 660.5,736.4 742.4,736.4  742.4,710.7 693.2,710.7 693.2,604.5  "
  }))), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000092449323169254088890000006774149065859407522_",
    style: {
      overflow: "visible",
      fill: "#FFFFFF"
    }
  }), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000125601038243703547320000009068562839688889760_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000092449323169254088890000006774149065859407522_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("rect", {
    x: 652.2,
    y: 596.3,
    style: {
      clipPath: "url(#SVGID_00000125601038243703547320000009068562839688889760_)",
      fill: "#FFFFFF"
    },
    width: 98.4,
    height: 148.4
  })), /*#__PURE__*/React.createElement("g", null, _defs13 || (_defs13 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "SVGID_00000181065455473301372620000010894930224941215678_",
    d: "M804.3,739.2c10,0,18.8-1.5,26.5-4.5 c7.7-3,13.7-7.3,18-13c4.3-5.7,6.5-12.6,6.5-20.8c0-8.2-1.7-14.3-5-19.4c-3.3-5.1-8-9.3-14.1-12.6c-6.1-3.4-13.1-6.4-21.2-9.2 c-5.6-2-10.7-3.9-15.1-5.7c-4.4-1.8-7.9-3.9-10.4-6.1c-2.5-2.2-3.8-4.9-3.8-8c0-4.3,1.6-7.6,4.9-9.7c3.3-2.2,7.9-3.2,13.9-3.2 c6,0,10.6,1.5,13.3,4.4c2.7,2.9,4.1,6.8,4.1,11.7v3.4h32.3v-5c0-8.7-2.2-15.9-6.5-21.8c-4.3-5.9-10.3-10.3-17.8-13.3 c-7.5-3-16.1-4.5-25.7-4.5c-9.6,0-17.7,1.5-25.2,4.5c-7.5,3-13.4,7.4-17.8,13.1c-4.4,5.7-6.6,12.5-6.6,20.6 c0,8.1,1.7,14.5,5.2,19.8c3.5,5.3,8.1,9.7,13.8,13.1c5.7,3.4,11.8,6.1,18.3,8.2c6,1.8,11.4,3.7,16.2,5.8s8.6,4.3,11.4,6.8 c2.8,2.5,4.2,5.2,4.2,8.3c0,4.3-1.7,7.3-5,9.2c-3.4,1.9-8.1,2.8-14.2,2.8c-6.1,0-10.8-1.5-13.8-4.6c-3-3.1-4.6-7.2-4.6-12.4v-4.3 h-32.4v5c0,9.2,2.2,16.9,6.5,23c4.3,6.2,10.3,10.8,18,13.9c7.6,3.1,16.3,4.7,26,4.7H804.3z"
  }))), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000181065455473301372620000010894930224941215678_",
    style: {
      overflow: "visible",
      fill: "#FFFFFF"
    }
  }), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000041979468016945115330000017274270744587373750_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000181065455473301372620000010894930224941215678_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("rect", {
    x: 745.4,
    y: 593.5,
    style: {
      clipPath: "url(#SVGID_00000041979468016945115330000017274270744587373750_)",
      fill: "#FFFFFF"
    },
    width: 118.2,
    height: 154
  })), /*#__PURE__*/React.createElement("g", null, _defs14 || (_defs14 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("polygon", {
    id: "SVGID_00000057118780373709907390000009564216727570788265_",
    points: "957,628.7 957,604.5 872.3,604.5 872.3,736.4  957,736.4 957,712.3 905.1,712.3 905.1,682.3 946.8,682.3 946.8,658.2 905.1,658.2 905.1,628.7  "
  }))), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000057118780373709907390000009564216727570788265_",
    style: {
      overflow: "visible",
      fill: "#FFFFFF"
    }
  }), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000163053653884744487040000003385405069042932127_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000057118780373709907390000009564216727570788265_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("rect", {
    x: 864,
    y: 596.3,
    style: {
      clipPath: "url(#SVGID_00000163053653884744487040000003385405069042932127_)",
      fill: "#FFFFFF"
    },
    width: 101.2,
    height: 148.4
  })), /*#__PURE__*/React.createElement("g", null, _defs15 || (_defs15 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("polygon", {
    id: "SVGID_00000110443083286358880820000014410627965109682365_",
    points: "27.9,910.3 112.6,910.3 112.6,886.2 60.7,886.2  60.7,856.2 102.5,856.2 102.5,832.1 60.7,832.1 60.7,802.6 112.6,802.6 112.6,778.5 27.9,778.5  "
  }))), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000110443083286358880820000014410627965109682365_",
    style: {
      overflow: "visible",
      fill: "#FFFFFF"
    }
  }), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000177474243266375109260000002673989671673512119_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000110443083286358880820000014410627965109682365_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("rect", {
    x: 19.6,
    y: 770.2,
    style: {
      clipPath: "url(#SVGID_00000177474243266375109260000002673989671673512119_)",
      fill: "#FFFFFF"
    },
    width: 101.2,
    height: 148.4
  })), /*#__PURE__*/React.createElement("g", null, _defs16 || (_defs16 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("polygon", {
    id: "SVGID_00000003082762647013365100000016375131358218162609_",
    points: "216.8,882.4 182,778.5 132.4,778.5 132.4,910.3  163.8,910.3 163.8,808.1 198.2,910.3 248.2,910.3 248.2,778.5 216.8,778.5  "
  }))), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000003082762647013365100000016375131358218162609_",
    style: {
      overflow: "visible",
      fill: "#FFFFFF"
    }
  }), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000049213046693605334810000017873534061314476960_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000003082762647013365100000016375131358218162609_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("rect", {
    x: 124.1,
    y: 770.2,
    style: {
      clipPath: "url(#SVGID_00000049213046693605334810000017873534061314476960_)",
      fill: "#FFFFFF"
    },
    width: 132.3,
    height: 148.4
  })), /*#__PURE__*/React.createElement("g", null, _defs17 || (_defs17 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("polygon", {
    id: "SVGID_00000169556193485811441450000015926161693328608135_",
    points: "267.9,910.3 352.7,910.3 352.7,886.2  300.8,886.2 300.8,856.2 342.5,856.2 342.5,832.1 300.8,832.1 300.8,802.6 352.7,802.6 352.7,778.5 267.9,778.5  "
  }))), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000169556193485811441450000015926161693328608135_",
    style: {
      overflow: "visible",
      fill: "#FFFFFF"
    }
  }), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000139275671314962391570000013460674836309166995_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000169556193485811441450000015926161693328608135_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("rect", {
    x: 259.7,
    y: 770.2,
    style: {
      clipPath: "url(#SVGID_00000139275671314962391570000013460674836309166995_)",
      fill: "#FFFFFF"
    },
    width: 101.2,
    height: 148.4
  })), /*#__PURE__*/React.createElement("g", null, _defs18 || (_defs18 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "SVGID_00000130614170464516487710000014320922771450998459_",
    d: "M436.2,828c-1.5,2.7-3.5,4.7-6,6.1 c-2.6,1.4-5.5,2.2-8.8,2.2h-17.6v-33.7H421c5.4,0,9.7,1.5,12.8,4.5c3.1,3,4.6,6.9,4.6,11.6C438.4,822.2,437.7,825.3,436.2,828 L436.2,828z M467.4,832.9c2.6-4.7,3.9-10.5,3.9-17.3c0-11.8-3.5-20.9-10.5-27.4c-7-6.5-17.7-9.7-32.2-9.7h-56.1v131.8h31.3v-50 H421c5.6,0,9.6,1.4,12,4.2c2.4,2.8,3.6,6.7,3.6,11.6V896c0,3,0.3,5.8,0.8,8.4c0.5,2.6,1.2,4.5,2,5.9h32c-1-1.2-1.7-3.1-2.2-5.8 c-0.5-2.7-0.7-5.5-0.7-8.5v-23.5c0-5.8-1-10.5-3.1-14c-2.1-3.5-4.7-6-8.1-7.6c-3.3-1.6-6.8-2.5-10.6-2.7c3.7-0.3,7.4-1.8,11.2-4.3 C461.6,841.3,464.8,837.6,467.4,832.9L467.4,832.9z"
  }))), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000130614170464516487710000014320922771450998459_",
    style: {
      overflow: "visible",
      fill: "#FFFFFF"
    }
  }), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000094576719514480852500000002696585635637194152_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000130614170464516487710000014320922771450998459_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("rect", {
    x: 364.2,
    y: 770.2,
    style: {
      clipPath: "url(#SVGID_00000094576719514480852500000002696585635637194152_)",
      fill: "#FFFFFF"
    },
    width: 115.4,
    height: 148.4
  })), /*#__PURE__*/React.createElement("g", null, _defs19 || (_defs19 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "SVGID_00000167394560461993167860000002457100652616187822_",
    d: "M589.4,791.9c-4.1-4.7-9.5-8.6-16.1-11.7 c-6.6-3-14.7-4.5-24.2-4.5c-11.3,0-21.5,2.6-30.7,8c-9.2,5.4-16.5,13.1-22,23.4c-5.4,10.3-8.2,22.8-8.2,37.7 c0,14.9,2.5,27.4,7.7,37.6c5.1,10.1,12,17.8,20.7,23c8.7,5.2,18.3,7.8,28.9,7.8c6.1,0,11.4-0.6,15.8-1.9c4.4-1.3,8.1-2.8,10.9-4.7 c2.8-1.9,5.1-3.7,6.6-5.7c1.6-1.9,2.6-3.5,3-4.7l3,14.7h15.7v-68.1h-52.2v22.7h24v6.9c-0.5,2.3-1.8,4.6-3.7,7 c-2,2.4-4.6,4.4-8,6.1c-3.3,1.6-7.4,2.4-12.3,2.4c-3.4,0-6.8-0.7-10.1-2c-3.3-1.3-6.3-3.6-9-6.9c-2.6-3.2-4.8-7.7-6.4-13.2 c-1.6-5.6-2.4-12.5-2.4-21c0-11.1,1.4-19.9,4.2-26.2c2.8-6.4,6.4-10.9,10.8-13.5c4.4-2.7,8.8-4,13.4-4c3.4,0,6.4,0.6,9,1.7 c2.6,1.1,4.8,2.7,6.7,4.6c1.9,1.9,3.2,4.1,4.1,6.5c0.9,2.4,1.4,4.9,1.4,7.4v1.1h30.9v-1.1c0-4.3-0.9-9.1-2.8-14.3 C596.5,801.6,593.5,796.7,589.4,791.9L589.4,791.9z"
  }))), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000167394560461993167860000002457100652616187822_",
    style: {
      overflow: "visible",
      fill: "#FFFFFF"
    }
  }), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000080173954481465050670000006846484016183007360_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000167394560461993167860000002457100652616187822_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("rect", {
    x: 479.9,
    y: 767.4,
    style: {
      clipPath: "url(#SVGID_00000080173954481465050670000006846484016183007360_)",
      fill: "#FFFFFF"
    },
    width: 129.5,
    height: 154
  })), /*#__PURE__*/React.createElement("g", null, _defs20 || (_defs20 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "SVGID_00000155144808198710538020000004267989044675892645_",
    x: 620.9,
    y: 778.5,
    width: 31.1,
    height: 131.9
  }))), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000155144808198710538020000004267989044675892645_",
    style: {
      overflow: "visible",
      fill: "#FFFFFF"
    }
  }), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000100349959476251016260000006327279722927077300_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000155144808198710538020000004267989044675892645_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("rect", {
    x: 612.7,
    y: 770.2,
    style: {
      clipPath: "url(#SVGID_00000100349959476251016260000006327279722927077300_)",
      fill: "#FFFFFF"
    },
    width: 47.6,
    height: 148.4
  })), /*#__PURE__*/React.createElement("g", null, _defs21 || (_defs21 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("polygon", {
    id: "SVGID_00000107579475892723261670000011212510710248770179_",
    points: "674.6,910.3 759.3,910.3 759.3,886.2  707.4,886.2 707.4,856.2 749.2,856.2 749.2,832.1 707.4,832.1 707.4,802.6 759.3,802.6 759.3,778.5 674.6,778.5  "
  }))), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000107579475892723261670000011212510710248770179_",
    style: {
      overflow: "visible",
      fill: "#FFFFFF"
    }
  }), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000116193323191377224640000011184666539914620801_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000107579475892723261670000011212510710248770179_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("rect", {
    x: 666.3,
    y: 770.2,
    style: {
      clipPath: "url(#SVGID_00000116193323191377224640000011184666539914620801_)",
      fill: "#FFFFFF"
    },
    width: 101.2,
    height: 148.4
  })), /*#__PURE__*/React.createElement("g", null, _defs22 || (_defs22 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("polygon", {
    id: "SVGID_00000149343807890126419710000007376099900147324075_",
    points: "773.4,802.6 805.3,802.6 805.3,910.3  837.5,910.3 837.5,802.6 869.4,802.6 869.4,778.5 773.4,778.5  "
  }))), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000149343807890126419710000007376099900147324075_",
    style: {
      overflow: "visible",
      fill: "#FFFFFF"
    }
  }), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000066506665381747412970000012475759583928558475_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000149343807890126419710000007376099900147324075_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("rect", {
    x: 765.2,
    y: 770.2,
    style: {
      clipPath: "url(#SVGID_00000066506665381747412970000012475759583928558475_)",
      fill: "#FFFFFF"
    },
    width: 112.5,
    height: 148.4
  })), /*#__PURE__*/React.createElement("g", null, _defs23 || (_defs23 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("polygon", {
    id: "SVGID_00000149359876848564767750000001800283406946192279_",
    points: "886.4,910.3 971.1,910.3 971.1,886.2  919.2,886.2 919.2,856.2 960.9,856.2 960.9,832.1 919.2,832.1 919.2,802.6 971.1,802.6 971.1,778.5 886.4,778.5  "
  }))), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000149359876848564767750000001800283406946192279_",
    style: {
      overflow: "visible",
      fill: "#FFFFFF"
    }
  }), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000139997883176443105400000004955864384682196882_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000149359876848564767750000001800283406946192279_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("rect", {
    x: 878.1,
    y: 770.2,
    style: {
      clipPath: "url(#SVGID_00000139997883176443105400000004955864384682196882_)",
      fill: "#FFFFFF"
    },
    width: 101.2,
    height: 148.4
  })), /*#__PURE__*/React.createElement("g", null, _defs24 || (_defs24 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "SVGID_00000080921683022492888120000017022321243169430950_",
    d: "M1025.6,805.5c4.1-3,8.8-4.5,14.1-4.5 c4.4,0,8.2,0.9,11.4,2.7c3.2,1.8,5.8,4.3,7.8,7.5c2,3.1,3.3,6.8,3.9,11c0.2,1.6,0.4,3.3,0.4,5.1h32.2c0-4-0.5-8.2-1.6-12.5 c-1.7-6.7-4.8-13-9.3-18.9c-4.5-6-10.5-10.8-17.9-14.5c-7.4-3.7-16.4-5.6-26.9-5.6c-12.6,0-23.5,2.9-32.5,8.8 c-9,5.9-15.9,13.9-20.6,24.2c-4.7,10.3-7.1,22.2-7.1,35.7s2.4,25.4,7.1,35.7c4.7,10.3,11.6,18.5,20.6,24.3 c9,5.9,19.8,8.8,32.5,8.8c9.5,0,17.8-1.6,24.8-4.7c7-3.1,12.8-7.2,17.3-12.3c4.5-5.1,8-10.7,10.2-16.7c2.2-6.1,3.4-12.1,3.4-18 h-32.2c0,3.6-0.5,7-1.6,10.2c-1,3.2-2.6,6-4.6,8.4c-2,2.4-4.5,4.3-7.4,5.7c-2.9,1.4-6.2,2.1-9.9,2.1c-5.3,0-10-1.5-14.1-4.6 c-4.1-3.1-7.4-7.8-9.8-14.2c-2.4-6.4-3.6-14.7-3.6-24.7s1.2-18.3,3.6-24.6c2.4-6.4,5.7-11.1,9.8-14.1V805.5z"
  }))), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000080921683022492888120000017022321243169430950_",
    style: {
      overflow: "visible",
      fill: "#FFFFFF"
    }
  }), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000073685973629006182500000013696526545335667361_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000080921683022492888120000017022321243169430950_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("rect", {
    x: 971.3,
    y: 767.4,
    style: {
      clipPath: "url(#SVGID_00000073685973629006182500000013696526545335667361_)",
      fill: "#FFFFFF"
    },
    width: 132.3,
    height: 154
  })), /*#__PURE__*/React.createElement("g", null, _defs25 || (_defs25 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("polygon", {
    id: "SVGID_00000085946909927695238260000001826071128460192142_",
    points: "1189.8,832.6 1144.9,832.6 1144.9,778.5  1112.3,778.5 1112.3,910.3 1144.9,910.3 1144.9,856.8 1189.8,856.8 1189.8,910.3 1222.4,910.3 1222.4,778.5 1189.8,778.5  "
  }))), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000085946909927695238260000001826071128460192142_",
    style: {
      overflow: "visible",
      fill: "#FFFFFF"
    }
  }), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000137127535991560273800000001346873515788794271_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000085946909927695238260000001826071128460192142_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("rect", {
    x: 1104,
    y: 770.2,
    style: {
      clipPath: "url(#SVGID_00000137127535991560273800000001346873515788794271_)",
      fill: "#FFFFFF"
    },
    width: 126.7,
    height: 148.4
  })), /*#__PURE__*/React.createElement("g", null, _defs26 || (_defs26 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("polygon", {
    id: "SVGID_00000158717413084895117620000008599026338668082847_",
    points: "1329.5,882.4 1294.6,778.5 1245,778.5  1245,910.3 1276.5,910.3 1276.5,808.1 1310.8,910.3 1360.8,910.3 1360.8,778.5 1329.5,778.5  "
  }))), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000158717413084895117620000008599026338668082847_",
    style: {
      overflow: "visible",
      fill: "#FFFFFF"
    }
  }), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000033330390382750038040000010883098165728340876_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000158717413084895117620000008599026338668082847_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("rect", {
    x: 1236.8,
    y: 770.2,
    style: {
      clipPath: "url(#SVGID_00000033330390382750038040000010883098165728340876_)",
      fill: "#FFFFFF"
    },
    width: 132.3,
    height: 148.4
  })), /*#__PURE__*/React.createElement("g", null, _defs27 || (_defs27 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "SVGID_00000158730084081818745440000018307119243351677092_",
    x: 1380.6,
    y: 778.5,
    width: 31.1,
    height: 131.9
  }))), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000158730084081818745440000018307119243351677092_",
    style: {
      overflow: "visible",
      fill: "#FFFFFF"
    }
  }), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000064354354999604619520000006111059470396159385_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000158730084081818745440000018307119243351677092_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("rect", {
    x: 1372.3,
    y: 770.2,
    style: {
      clipPath: "url(#SVGID_00000064354354999604619520000006111059470396159385_)",
      fill: "#FFFFFF"
    },
    width: 47.6,
    height: 148.4
  })), /*#__PURE__*/React.createElement("g", null, _defs28 || (_defs28 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("polygon", {
    id: "SVGID_00000049910670172104123830000002630326686731016621_",
    points: "1431.4,910.3 1516.1,910.3 1516.1,886.2  1464.2,886.2 1464.2,856.2 1506,856.2 1506,832.1 1464.2,832.1 1464.2,802.6 1516.1,802.6 1516.1,778.5 1431.4,778.5  "
  }))), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000049910670172104123830000002630326686731016621_",
    style: {
      overflow: "visible",
      fill: "#FFFFFF"
    }
  }), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000168797979023882427740000003297601146061873050_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000049910670172104123830000002630326686731016621_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("rect", {
    x: 1423.1,
    y: 770.2,
    style: {
      clipPath: "url(#SVGID_00000168797979023882427740000003297601146061873050_)",
      fill: "#FFFFFF"
    },
    width: 101.2,
    height: 148.4
  })), /*#__PURE__*/React.createElement("g", null, _defs29 || (_defs29 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("polygon", {
    id: "SVGID_00000163795009533401033970000000938874184412424578_",
    points: "1643.5,778.5 1609.3,778.5 1568.3,834.6  1568.3,778.5 1535.9,778.5 1535.9,910.3 1568.3,910.3 1568.3,876.6 1581.4,859.1 1610.7,910.3 1646,910.3 1600.3,835.7  "
  }))), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000163795009533401033970000000938874184412424578_",
    style: {
      overflow: "visible",
      fill: "#FFFFFF"
    }
  }), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000127026965825696321930000002463227352998140597_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000163795009533401033970000000938874184412424578_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("rect", {
    x: 1527.6,
    y: 770.2,
    style: {
      clipPath: "url(#SVGID_00000127026965825696321930000002463227352998140597_)",
      fill: "#FFFFFF"
    },
    width: 126.7,
    height: 148.4
  })), /*#__PURE__*/React.createElement("g", null, _defs30 || (_defs30 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("polygon", {
    id: "SVGID_00000182523106853901728370000004521198205035927941_",
    points: "1660.1,910.3 1744.9,910.3 1744.9,886.2  1693,886.2 1693,856.2 1734.7,856.2 1734.7,832.1 1693,832.1 1693,802.6 1744.9,802.6 1744.9,778.5 1660.1,778.5  "
  }))), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000182523106853901728370000004521198205035927941_",
    style: {
      overflow: "visible",
      fill: "#FFFFFF"
    }
  }), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000113346044836504021040000010056951482744338866_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000182523106853901728370000004521198205035927941_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("rect", {
    x: 1651.9,
    y: 770.2,
    style: {
      clipPath: "url(#SVGID_00000113346044836504021040000010056951482744338866_)",
      fill: "#FFFFFF"
    },
    width: 101.2,
    height: 148.4
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, _defs31 || (_defs31 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("polygon", {
    id: "SVGID_00000040553403147398404810000010297116453967957155_",
    points: "1849.1,882.4 1814.2,778.5 1764.6,778.5  1764.6,910.3 1796.1,910.3 1796.1,808.1 1830.5,910.3 1880.4,910.3 1880.4,778.5 1849.1,778.5  "
  }))), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000040553403147398404810000010297116453967957155_",
    style: {
      overflow: "visible",
      fill: "#FFFFFF"
    }
  }), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000179623715941560003710000011138175490959291825_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000040553403147398404810000010297116453967957155_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("rect", {
    x: 1756.4,
    y: 770.2,
    style: {
      clipPath: "url(#SVGID_00000179623715941560003710000011138175490959291825_)",
      fill: "#FFFFFF"
    },
    width: 132.3,
    height: 148.4
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, _defs32 || (_defs32 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "SVGID_00000096771041301820831110000005800661861024589500_",
    x: 16.6,
    y: 472.7,
    width: 1875.1,
    height: 50.5
  }))), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000096771041301820831110000005800661861024589500_",
    style: {
      overflow: "visible",
      fill: "#FFFFFF"
    }
  }), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000032619143388468774690000005957436603063731076_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000096771041301820831110000005800661861024589500_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("rect", {
    x: 8.3,
    y: 464.4,
    style: {
      clipPath: "url(#SVGID_00000032619143388468774690000005957436603063731076_)",
      fill: "#FFFFFF"
    },
    width: 1891.6,
    height: 67
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMeetecbanner);
export default __webpack_public_path__ + "static/media/meetecbanner.ecb057bb1befb9f6334fde5498720beb.svg";
export { ForwardRef as ReactComponent };